import { jsxs, jsx } from "react/jsx-runtime";
import { Text } from "@wix/wix-ui-tpa/cssVars";
import { useState, useMemo } from "react";
import { useConfig } from "../../../contexts/config-context.js";
import { useFieldActions } from "../../../contexts/field-actions-context.js";
import { useTranslation } from "../../../contexts/translation-context.js";
import { useSlotSelectedFromTP } from "../actions/slot-selected-from-tp/index.js";
import { bulkSlotsSize } from "../appointment-state.js";
import { Components, Actions } from "../bi-types.js";
import { useAppointmentContext } from "../context/appointment-context.js";
import { useAppointmentBi } from "../utils/bi.js";
import { formatTimezone } from "../utils/format-timezone.js";
import { DatePicker } from "./datepicker/datepicker-wut.js";
import { TimeSlots } from "./slots/index.js";
import { classes } from "./time-slot-picker.st.css";
import { LOCATIONS_METHOD } from "./types.js";
const TimeSlotPicker = ({
  visibility = "visible",
  fieldId
}) => {
  const { language, isComposer, isEditor } = useConfig();
  const { t } = useTranslation();
  const { appointmentFieldProps, appointmentState, setAppointmentState } = useAppointmentContext();
  const bi = useAppointmentBi();
  const { formatDescription, locationType } = appointmentFieldProps;
  const [isReloadingSlots, setIsReloadingSlots] = useState(false);
  const [isFetchingDates, setIsFetchingDates] = useState(false);
  const { actions } = useFieldActions();
  useSlotSelectedFromTP({
    setIsReloadingSlots
  });
  const timezone = useMemo(
    () => formatTimezone({
      timezone: appointmentState.timezone,
      language
    }),
    [appointmentState.timezone, language]
  );
  const onDateClicked = async (data) => {
    if (data?.selectedDate) {
      setIsReloadingSlots(true);
      setAppointmentState({
        selectedDate: data.selectedDate
      });
      bi?.report({
        action: Actions.CLICK,
        component: Components.DATE
      });
      const availabilitySlotsToUpdate = await actions?.getAvailabilitySlots?.({
        serviceId: appointmentFieldProps?.initialData.service.id,
        timeZone: appointmentState?.timezone || "",
        selectedDate: data.selectedDate
      });
      setAppointmentState({
        currentSlotBulkSize: bulkSlotsSize,
        selectedDate: data.selectedDate,
        availabilitySlots: availabilitySlotsToUpdate
      });
      appointmentFieldProps?.onChange(void 0);
      setIsReloadingSlots(false);
    }
  };
  const handleOnWeekChange = async (fromDate, toDate) => {
    if (isComposer || isEditor) {
      return;
    }
    setIsFetchingDates(true);
    bi?.report({
      action: Actions.CLICK,
      component: Components.PAGINATION
    });
    const availabilityDates = await actions?.getAvailabilityDates?.({
      serviceId: appointmentFieldProps?.initialData.service.id,
      timeZone: appointmentState?.timezone || "",
      fromDate,
      toDate
    });
    setAppointmentState({
      availabilityDates
    });
    setIsFetchingDates(false);
  };
  return /* @__PURE__ */ jsxs("div", { style: { visibility }, children: [
    /* @__PURE__ */ jsx(
      DatePicker,
      {
        availableDates: appointmentState.availabilityDates,
        selectedDate: appointmentState.selectedDate,
        onDateChange: (date) => onDateClicked({ selectedDate: date }),
        onWeekChange: handleOnWeekChange,
        disabled: isReloadingSlots || isFetchingDates
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: classes.textRegion, children: [
      /* @__PURE__ */ jsx(Text, { tagName: "span", className: classes.paragraph, children: `${t("form.appointment.timezone.label")}: ${timezone}` }),
      /* @__PURE__ */ jsx(Text, { tagName: "span", className: classes.paragraph, children: locationType === LOCATIONS_METHOD.OS_LOCATION ? t(
        "form.appointment.meeting-format.in-person-location-method-os-location"
      ) : formatDescription })
    ] }),
    /* @__PURE__ */ jsx(TimeSlots, { isReloadingSlots, fieldId })
  ] });
};
export {
  TimeSlotPicker
};
//# sourceMappingURL=index.js.map
